import {Unserializer} from './serialization';

export class Partner implements Partner {
  partnerId: number;
  parentPartnerId?: number;
  name: string;
  children: Partner[];
  created: Date;
  updated: Date;

  static copy(oldObj: Partner): Partner {
    const newObj = new Partner();
    newObj.partnerId = oldObj.partnerId;
    newObj.parentPartnerId = oldObj.parentPartnerId;
    newObj.name = oldObj.name;
    newObj.created = oldObj.created;
    newObj.updated = Unserializer.date(oldObj.updated);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.partnerId;
  }

  isNew(): boolean {
    return isNaN(this.partnerId);
  }

  clone(): Partner {
    return Partner.copy(this);
  }
}
